import { render, staticRenderFns } from "./BreadcrumbsTable.vue?vue&type=template&id=b2079ef4&"
import script from "./BreadcrumbsTable.vue?vue&type=script&lang=ts&"
export * from "./BreadcrumbsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports